import CallingProvider from 'calling-internal-common/call-provider/records/CallingProvider';
import { getSetting } from '../../local-settings/localSettings';
const CALLING_EXTENSIONS_KEY = 'CallingExtensions';
const OLD_LOCAL_SETTINGS_PREFIX = 'LocalSettings:Sales:';

/**
 * Retrieves and validates the LocalSettings:Calling:CallingExtensions value from local storage.
 * @returns widget info if valid, null otherwise
 */
export const getExtensionsWidgetValue = () => {
  const localStorageValue = getSetting(CALLING_EXTENSIONS_KEY) || getSetting(CALLING_EXTENSIONS_KEY, null, undefined, OLD_LOCAL_SETTINGS_PREFIX);
  if (localStorageValue && typeof localStorageValue === 'object') {
    return new CallingProvider(localStorageValue).toJS();
  }
  return null;
};